import {createContext, useState, ReactNode, useEffect} from "react";

interface IContextPropviderProps {
  children?: ReactNode | ReactNode[];
}

interface ISize {
  w: number,
  h: number
}

export interface IImageContext {
  size: ISize,
  setSize: (size: ISize) => void,
  croppedImage: string;
  croppedImage2: string; // zoomed image
  setCroppedImage: (img: string) => void;
  setCroppedImage2: (img: string) => void;
  schema: any[],
  quantity: string,
  sessionId?: string,
  setQuantity: (quantity: string) => void,
  setSchema: (schema: any[]) => void;
  userEmail: string;
  setUserEmail: (email: string) => void;
  setSessionId: (id: string) => void;
  loadingStatus: boolean;
  setLoadingStatus: (status: boolean) => void;
  imageUrl: string;
  setImageUrl: (url: string) => void;
  croppedAreaPixels: any;
  setCroppedAreaPixels: (x: any) => void;
}

const initContext: IImageContext = {
  size: {w: 64, h: 64},
  croppedImage: '',
  croppedImage2: '',
  schema: [],
  userEmail: '',
  quantity: '',
  loadingStatus: false,
  imageUrl: '',
  croppedAreaPixels: null,
  setQuantity: () => {},
  setCroppedImage: () => {},
  setCroppedImage2: () => {},
  setSize: () => {},
  setSchema: () => {},
  setUserEmail: () => {},
  setSessionId: () => {},
  setLoadingStatus: () => {},
  setImageUrl: () => {},
  setCroppedAreaPixels: () => {}
}

export const ImageContext = createContext<IImageContext>(initContext);

export const ImageContextProvider = ({children}: IContextPropviderProps) => {
  const [croppedImage, setCroppedImage] = useState('');
  const [croppedImage2, setCroppedImage2] = useState('');
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [size, setSize] = useState<ISize>({w: 64, h: 64});
  const [schema, setSchema] = useState([]);
  const [userEmail, setUserEmail] = useState('');
  const [quantity, setQuantity] = useState('');
  const [sessionId, setSessionId] = useState('');
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    switch (quantity) {
      case '1':
        setSize({w: 64, h: 64});
        break;
      case '2':
        setSize({w: 64, h: 128});
        break;
      case '3':
        setSize({w: 128, h: 128});
        break;
    }
  }, [quantity]);

  const value: IImageContext = {
    size,
    setSize,
    croppedImage,
    croppedImage2,
    setCroppedImage,
    setCroppedImage2,
    schema, setSchema,
    userEmail, setUserEmail,
    quantity, setQuantity,
    sessionId, setSessionId,
    loadingStatus, setLoadingStatus,
    imageUrl, setImageUrl,
    croppedAreaPixels, setCroppedAreaPixels,
  }

  return (
    <ImageContext.Provider value={value}>{children}</ImageContext.Provider>
  );
}
